// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { useEffect } from 'react';
import { FieldValues, Path, useFormContext } from 'react-hook-form';
import FieldLabel from '../../../../../components/stepper/field-components/FieldLabel';
import { CustomFieldProps } from 'components/stepper/field-components/QuestionnaireField';
import { FormInput } from '../../../../../components/stepper/field-components';
import { Checkbox } from '../../../../../components/stepper/field-components/FormCheckboxGroup';

export const I_DO_NOT_KNOW_VALUE = 'I do not know';

const BloodPressureField = <T extends FieldValues>({
  question,
  isRequired,
  isDisabled,
}: CustomFieldProps & { isDisabled?: boolean }) => {
  const idStr = String(question.id) as Path<T>;

  const idkName = `${idStr}.idk` as Path<T>;
  const systolicName = `${idStr}.value.0` as Path<T>;
  const diastolicName = `${idStr}.value.1` as Path<T>;

  const { watch, setValue, clearErrors } = useFormContext<T>();

  const isChecked = !!watch(idkName);

  useEffect(() => {
    if (!isChecked) return;

    setValue(`${idStr}.value` as Path<T>, ['', ''] as [string, string], {
      shouldDirty: true,
      shouldTouch: true,
    });

    clearErrors([systolicName, diastolicName, `${idStr}.value` as Path<T>]);
  }, [isChecked, idStr, setValue, clearErrors, systolicName, diastolicName]);

  return (
    <div className="flex flex-col">
      <div className="mb-2.5">
        <FieldLabel
          label={question.text}
          isRequired={isRequired}
          name={idStr}
        />
      </div>

      <Checkbox
        label={I_DO_NOT_KNOW_VALUE}
        checked={isChecked}
        onChange={(checked) =>
          setValue(idkName, checked as boolean, {
            shouldDirty: true,
            shouldTouch: true,
          })
        }
      />

      <div className="grid grid-cols-1 gap-2.5 md:grid-cols-2 mt-2.5">
        <FormInput
          type="number"
          name={systolicName}
          label={question.double_text_combo_helper_texts?.helper_text_1}
          describe={'Valid range 80-180 mmHg'}
          isRequired={isRequired}
          disabled={isDisabled || isChecked}
        />

        <FormInput
          type="number"
          name={diastolicName}
          label={question.double_text_combo_helper_texts?.helper_text_2}
          describe={'Valid range 60-120 mmHg'}
          isRequired={isRequired}
          disabled={isDisabled || isChecked}
        />
      </div>
    </div>
  );
};

export default BloodPressureField;
